import React, { FunctionComponent, SVGProps } from 'react';

import styled, { css, useTheme } from 'styled-components';

export interface CircleAddIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
  iconSize?: number;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CircleAddIcon: FunctionComponent<CircleAddIconProps> = ({
  className,
  onClick,
}) => {
  const theme = useTheme();
  return (
    <svg
      className={className}
      onClick={(ev) => (onClick ? onClick(ev) : null)}
      viewBox="0 0 24 24"
    >
      <path
        className="circle"
        fill={theme.colors.primary}
        d="m12,0h0c6.63,0,12,5.37,12,12h0c0,6.63-5.37,12-12,12h0C5.37,24,0,18.63,0,12h0C0,5.37,5.37,0,12,0Z"
      />
      <path
        fill={theme.colors.differentBackground}
        d="m12,5.98h0c.55,0,1,.45,1,1v10c0,.55-.45,1-1,1h0c-.55,0-1-.45-1-1V6.98c0-.55.45-1,1-1Z"
      />
      <path
        fill={theme.colors.differentBackground}
        d="m18,11.98h0c0,.55-.45,1-1,1H7c-.55,0-1-.45-1-1h0c0-.55.45-1,1-1h10c.55,0,1,.45,1,1Z"
      />
    </svg>
  );
};

export default styled(CircleAddIcon)`
  width: ${(props) => (props.iconSize ? props.iconSize : '24')}px;
  height: ${(props) => (props.iconSize ? props.iconSize : '24')}px;

  ${(props) =>
    props.onClick
      ? css`
          cursor: pointer;
          .circle {
            transition: fill
              ${({ theme }) =>
                `${theme.transitions.duration} ${theme.transitions.type}`};
          }
          &:hover {
            .circle {
              fill: ${({ theme }) => theme.colors.secondaryHover};
            }
          }
        `
      : null}
`;
